module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "command-input"
    }
  }, [_c('prompt'), _vm._v(" "), _c('pre', {
    staticClass: "command"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('caret')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f03467e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommandInput.vue
// module id = 274
// module chunks = 1